import React from "react";

import { getTranslation } from "../../helpers/getLanguage";
import ConfirmationModal from "../dialogs/ConfirmationModal";
import { WarningDeleteComponentsAndAttributes } from "./WarningDeleteComponentsAndAttributes/WarningDeleteComponentsAndAttributes";

export const ConfirmationModalForRemovingComponentsAndAttributes = ({
  warningData,
  deleteSelectedComponentsAndAttributes,
  setWarningData,
  setModalOpen,
  type,
  productType,
}) => {
  const handleClose = () => setModalOpen((prev) => ({ ...prev, archiveChecked: false }));
  const handleSubmit = () => {
    deleteSelectedComponentsAndAttributes();
    handleClose();
  };

  if (type === "empty") {
    return (
      <ConfirmationModal
        className="warning-delete-modal"
        closeDialog={handleClose}
        autoFocus={true}
        buttonText={"OK"}
        onConfirm={handleClose}
        message={getTranslation(
          productType === "process"
            ? "CONFIRMATION_MESSAGE_TO_DELETE_STEPS_OR_ATTRIBUTES"
            : "CONFIRMATION_MESSAGE_TO_DELETE_COMPONENTS_OR_ATTRIBUTES",
        )}
      />
    );
  }

  if (warningData) {
    return (
      <ConfirmationModal
        className="delete-selected-components"
        closeDialog={() => {
          setWarningData(null);
          handleClose();
        }}
        autoFocus={true}
        buttonText={getTranslation("EDIT_ATTRIBUTE_DIALOG_BUTTON_DELETE")}
        cancelButton={getTranslation("WARNING_MODAL_CANCEL_BUTTON_TEXT")}
        onConfirm={handleSubmit}
      >
        <WarningDeleteComponentsAndAttributes type={type} warningData={warningData} />
      </ConfirmationModal>
    );
  }

  return (
    <ConfirmationModal
      className="warning-delete-modal"
      closeDialog={() => setModalOpen((prev) => ({ ...prev, archiveChecked: false }))}
      autoFocus={true}
      buttonText={getTranslation("EDIT_ATTRIBUTE_DIALOG_BUTTON_DELETE")}
      onConfirm={handleSubmit}
      cancelButton={getTranslation("WARNING_MODAL_CANCEL_BUTTON_TEXT")}
      message={getTranslation(
        type === "single"
          ? "CONFIRM_MODAL_DELETE_ONE_COMPONENT_OR_ATTRIBUTE"
          : "CONFIRM_MODAL_DELETE_COMPONENTS_AND_ATTRIBUTES",
      )}
    />
  );
};
